/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
export const SectionArticleQuery = (productCode: string, sectionName: string) => {
    return `query MyQuery {
        aBILITYPage(where: {productContent: {productName: "${productCode}"}, tag: {tagName: "${sectionName}"}}, orderBy: {publishedUtc: DESC}) {
            productContent {
                productName
            }
            sectionTags {
                termContentItems {
                    contentItemId
                    displayText
                }
            }
            contentItemId
            displayText
            path
        }
        pdf(where: {productContent: {productName: "${productCode}"}}, orderBy: {publishedUtc: ASC}, first: 1000) {
            pdfDocument {
                relativePdfPath
            }
            sectionTags {
                termContentItems {
                    displayText
                    contentItemId
                }
            }
            productContent {
                productName
            }
            displayText
            contentItemId
        }
    }`
}